import requestWithRetry from 'civic-champs-shared/api/requestWithRetry'

/** Returns { features } or { error }; used by auth bootstrap and feature sagas. */
export default async function fetchFeaturesForOrg(orgId) {
  if (!orgId) return { features: {} }

  try {
    const features = await requestWithRetry({ url: `/organizations/${orgId}/features` })
    return { features }
  } catch (error) {
    return { error }
  }
}
